import { Molecule } from "AppReact";
import styled, { css } from "styled-components";
import { EditPencilSvg } from "components/icons";
import getIsMobile from "components/atoms/utils/getIsMobile";
import { ClickableIcon } from "../atoms";

const isMobile = getIsMobile();

const template = styled.label`
  ${({ isHovered }) => css`
    cursor: pointer;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    background: #ffffff;
    border: 1px solid #e3e3e3;
    display: grid;
    place-items: center;
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 3;
  `}
`;

export default Molecule({
  template,
  type: "dropFiles",
  atoms: [
    {
      component: ClickableIcon,
      name: "FilePickerButton",
      displayValue: ({}) =>
        EditPencilSvg({
          width: 14,
          height: 14,
          color: "#04333B",
        }),
    },
  ],
});
